var exports = {
  "m": "MessageActionBottomSheet.module__quickReactionWrapper___YTh6dX",
};

module.exports = exports;
